import {Query as q} from 'typeQuery/query/query';

import { QueryItemsList } from "typeQuery/query/queryItemsList";
import { QueryItem } from "typeQuery/query/queryItem";
import { delay } from "typeQuery/utils/delay";

type qLogosOptions = {
	logoWidth: number,
}

export class LogoSlider {
	private options: qLogosOptions;

	private qLogos:QueryItemsList;
	private qLogoTrack:QueryItem;
	private qLogoContainer:QueryItem;

	constructor(logoContainer:string) {
		this.options = {
			logoWidth: 180
		};
		this.qLogoContainer = q(logoContainer).first;

		if(this.qLogoContainer) {
			this.buildHtml();
		}
	}

	buildHtml():void {
		

		this.qLogoContainer.class.add('qLogos-container');

		this.qLogos = this.qLogoContainer.children();
		if(this.qLogos.count == 0) {
			return;
		}
		this.qLogoTrack = q(this.qLogoContainer.append('<div class="qLogos-track"></div>', 'afterbegin'));

		this.qLogos.each(qLogo => {
			qLogo.style.width = this.options.logoWidth + 'px';
			qLogo.style.cssFloat = 'left';
			qLogo.moveInto(this.qLogoTrack);

		});
		console.log(this.qLogoTrack.element.clientWidth);
		if(this.qLogoTrack.element.clientWidth == 0) {
			return;
		}
		
		
		do {
			this.qLogoTrack.children().each(qLogo => {
				this.qLogoTrack.append(qLogo.clone(true));
			});
			this.qLogoTrack.style.width = this.qLogoTrack.children().count * this.options.logoWidth + 'px';
		} while(this.qLogoTrack.element.clientWidth <= this.qLogoContainer.element.clientWidth*2);

		this.qLogoTrack.style.animationDuration = this.qLogoTrack.children().count + 's'
		
	}
}


// WEBPACK FOOTER //
// ./logos-slider.ts